import { NoOpFlagsManager } from '@databases/flags';
import { NoOpPanelManager } from '@databases/panel/managers';
import { PluginsManager, PluginKey, type PluginsState } from '@databases/plugins';

import { type ModeConfig } from './base-mode-config';

const pluginsState: PluginsState = {
  [PluginKey.CELL_SELECTION]: () => false,
  [PluginKey.COMMENTS]: () => false,
  [PluginKey.CONTEXT_MENU]: () => false,
  [PluginKey.DATABASE_ACTIONS]: () => false,
  [PluginKey.EDIT_CONTENT]: () => false,
  [PluginKey.INLINE_DATABASE_NAME]: () => false,
  [PluginKey.QUICK_CALCULATIONS]: () => false,
  [PluginKey.VIEW_SETTINGS_ACTIONS]: () => false,
  [PluginKey.VIEW_SETTINGS_BUTTONS]: () => false,
};

export function createMobileModeConfig(): ModeConfig {
  return {
    dependencies: {
      FlagsManager: () => new NoOpFlagsManager(),
      PluginsManager: () => new PluginsManager(pluginsState),
      PanelManager: () => new NoOpPanelManager(),
    },
  };
}
